export default {
    // search limit popup
    tooManySearchRequests: "蒐索請求太多",
    reachedTheLimitForRealTime: "您已達到“實时”蒐索的限制。",
    useTheRecentModeToExploreResults: " 與此同時，您可以使用“最近”模式僅基於我們資料庫中已有的數據來探索結果",
    btnTryLaterAgain: "稍後再試",
    btnUseRecentMode: "使用最近模式",

    // Create New Sequence
    createNewSequence: '創建新流程',
    sequenceName: "流程名稱",
    enterSequenceName: "請輸入流程名稱",

    // Not enough credits
    uDontHaveEnoughCredits: "您沒有足够的信用點",
    addMinimumCredits: "是否要添加 {count} 信用點（最低充值金額）以繼續搜索？",
    btnAddCredits: "新增信用點",

    // Payment Method Required
    paymentMethodRequired: "需添加付款方式",
    dontHaveAPaymentMethodLinkedToYourAccount: '看起來您的帳戶沒有連結付款方式。',
    pleaseAddYourPaymentMethodToContinue: "請添加您的付款方式以繼續。",
    btnAddNow: '立即添加',

    // Credit Running Low!
    creditRunningLow: "信用點餘額低！",
    yourCreditIsRunningLow: "您的信用額度不足，我們無法處理自動充值。",
    pleaseManuallyTopupYourCredit: "請手動充值您的信用額度，以避免服務中斷。",
    btnTopup: "現在充值",

    // You've Reached Your Limit
    uHaveReachedYourLimit: "您的蒐索已達到限制數量",
    subscriptionTiers: "訂閱級別",
    switchPlansSeamlessly: "無縫切換計畫——您剩餘的積分將作為充值積分轉移，以備將來使用。",
    tabMonthly: "按月",
    tabAnnual: "按年",
    tableFieldCredits: "信用點",
    tableFieldTopupCredit: '信用點充值',
    tableFieldPageLimit: "頁面上限",
    tableFieldExportLimit: "匯出上限",
    tableFieldAPI: "API",
    tableFieldRolePermission: '自定義角色許可權',
    tableFieldTeamManagement: "團隊管理",
    tableFieldPrice: "價格-每位用戶，每月計費",
    tableFieldFeatures: "特色",
    titleTiers: "等級",
    btnChangePlan: '選擇計畫',
    btnCurrentPlan: '當前計畫',

    // Upgrade to Unlock This Feature
    upgradeToUnlockThisFeature: "陞級以解鎖此功能",
    thisFeatureIsAvailableOnlyForUpgradedPlanUsers: '此功能僅適用於陞級的計畫用戶。',
    upgradeYourPlanToEnjoyEnhancedFunctionality: '陞級您的計畫，享受增强的功能，並解鎖更多根據您的需求量身定制的可能性。',
    btnBack: '返回',
    btnUpgradeNow: '現在陞級'
};